// import { setFlagsFromString } from "v8";
import http from "../axios/http-common";

class InterfaceList {
  // getAllbyStatus(st: string, tgl: string) {
  //   return http.get(`/pasien/status/${st}/${tgl}`);
  // }
  getPasien(kdPoli, tgl, status, kdDokter) {
    return http.getDataParam(`/poli/${kdPoli}/daftar-pasien`, {
      // return http.getDataParam(`/poli/daftar-pasien/${kdPoli}`, {
      // return http.get(`/poli/${kdPoli}/daftar-pasien`, {
      params: {
        tgl: tgl,
        status: status,
        dr: kdDokter
      }
    });
  }

  getPasienKonsulan(kdPoli, sort, tglStart, tglEnd) {
    return http.getDataParam(`/poli/${kdPoli}/daftar-pasien-konsul`, {
      // return http.getDataParam(`/poli/daftar-pasien-konsul/${kdPoli}`, {
      params: {
        sort: sort,
        tgl_start: tglStart,
        tgl_end: tglEnd
      }
    });
  }
  getPasienRanap(kdUnit) {
    return http.getData(`/unit-ranap/${kdUnit}/daftar-pasien`);
  }

  getPasienUnit(kdUnit) {
    return http.getData(`/unit/${kdUnit}/daftar-pasien`);
  }
}

export default new InterfaceList();
